import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { API, auth, inputClass, labelClass, primaryBtn, handleAuthError } from "./shared";

const AdminPassword = ({ token, logout }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("Les deux nouveaux mots de passe ne correspondent pas");
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: form.current_password, new_password: form.new_password }, auth(token));
      toast.success("Mot de passe modifié");
      setForm({ current_password: "", new_password: "", confirm: "" });
      setOpen(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      handleAuthError(err, logout, () => toast.error(typeof d === "string" ? d : "Échec (8 caractères minimum)"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button data-testid="admin-change-password-button" className="flex items-center gap-2 rounded-full border border-brand/30 px-4 py-2.5 font-mono text-xs uppercase tracking-widest text-brand transition-colors hover:bg-mint">
          <KeyRound className="h-4 w-4" />
          Mon mot de passe
        </button>
      </DialogTrigger>
      <DialogContent className="rounded-3xl border-brand/10 bg-white p-8 sm:max-w-md" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold text-forest">Changer mon mot de passe</DialogTitle>
          <DialogDescription className="text-brand-hover">8 caractères minimum. Vous resterez connecté.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="mt-4 space-y-4">
          <div>
            <label className={labelClass}>Mot de passe actuel</label>
            <input type="password" required autoComplete="current-password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} data-testid="change-password-current-input" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Nouveau mot de passe</label>
            <input type="password" required minLength={8} autoComplete="new-password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} data-testid="change-password-new-input" className={inputClass} />
          </div>
          <div>
            <label className={labelClass}>Confirmer le nouveau mot de passe</label>
            <input type="password" required minLength={8} autoComplete="new-password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="change-password-confirm-input" className={inputClass} />
          </div>
          <button type="submit" disabled={saving} data-testid="change-password-submit-button" className={`w-full justify-center ${primaryBtn}`}>
            <KeyRound className="h-4 w-4" />
            {saving ? "Enregistrement..." : "Enregistrer"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AdminPassword;
